export const API_CONFIG = {
  baseURL: import.meta.env.VITE_WORDPRESS_URL || 'https://bonyanschool.ir',
  endpoints: {
    user: '/wp-json/interview/v1/user',
    userUpdate: '/wp-json/interview/v1/user/update',
    calendar: '/wp-json/interview/v1/calendar',
    bookSlot: '/wp-json/interview/v1/book-slot',
  },
  tokenKey: 'interview_jwt_token',
};
